const base = require('./product/base');
module.exports = {
    availability: base.availability,
    addToCart: base.addToCart,
    addSetToCart: base.addSetToCart,
    addToRegistry: base.addToRegistry,
    calculateBuyWithTotalPrice: base.calculateBuyWithTotalPrice(),
    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
    updateRecommendationBlock: base.updateRecommendationBlock(),
    confirmEsrb: base.confirmEsrb(),
    colorAttribute: base.colorAttribute(),
    selectAttribute: base.selectAttribute()
};
